import React from 'react';
import { IconProps } from './types';

export const P2pIcon = (props: IconProps) => {
  const { size = 24, color = 'currentColor', style = {} } = props;

  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.1424 20.5714V18.5714C17.1424 17.5106 16.7361 16.4932 16.0127 15.743C15.2894 14.9929 14.3083 14.5714 13.2853 14.5714H5.57101C4.54803 14.5714 3.56695 14.9929 2.8436 15.743C2.12024 16.4932 1.71387 17.5106 1.71387 18.5714V20.5714'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.99972 11.1428C11.13 11.1428 12.8569 9.41594 12.8569 7.2857C12.8569 5.15546 11.13 3.42856 8.99972 3.42856C6.86948 3.42856 5.14258 5.15546 5.14258 7.2857C5.14258 9.41594 6.86948 11.1428 8.99972 11.1428Z'
        fill='#1A1A1A'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22.2853 20.5714V18.5271C22.2847 17.6212 22.0319 16.7412 21.5665 16.0253C21.101 15.3093 20.4494 14.7979 19.7139 14.5714'
        stroke='#DFF60D'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.4287 3.42856C16.4095 3.64784 17.2788 4.14594 17.8996 4.84431C18.5203 5.54269 18.8573 6.40162 18.8573 7.2857C18.8573 8.16978 18.5203 9.02871 17.8996 9.72709C17.2788 10.4255 16.4095 10.9236 15.4287 11.1428'
        stroke='#DFF60D'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
